// TanStack Query hooks pro globální data aplikace (elements, station_types, basins, obs_types)
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { api } from '../api/client'
import { useStationStore } from '../store/stationStore'

export function useElements() {
  const { data = [] } = useQuery({
    queryKey: ['elements'],
    queryFn: () => api.get('/elements'),
    staleTime: Infinity,
  })
  const elementsMap = Object.fromEntries(data.map(e => [e.abbreviation, e]))
  return { elementsMap, elementsLoading: false }
}

export function useStationTypes() {
  const { data = [] } = useQuery({
    queryKey: ['stationTypes'],
    queryFn: () => api.get('/station_type?cache=[1440]'),
    staleTime: Infinity,
    //sort pokud je nutny, ale uz je setrideny z API
    //select: (data) => data.filter(t => t.id).sort((a, b) => a.id.localeCompare(b.id)),
  })
  return data
}

// Vrací { obs_type: [el_abbreviation, ...] } seřazené podle obs_type a el_abbreviation
export function useObsGroups() {
  const { data = {} } = useQuery({
    queryKey: ['obsTypes'],
    queryFn: () => api.get('/obs_type'),
    staleTime: Infinity,
    select: (rows) => {
      const groups = {}
      rows.forEach(({ obs_type, el_abbreviation }) => {
        if (!obs_type) return
        if (!groups[obs_type]) groups[obs_type] = []
        if (el_abbreviation) groups[obs_type].push(el_abbreviation)
      })
      return groups
    },
  })
  return data
}

// Seznam vlastníků stanic (geography.sow_name). API vrací jiný seznam pro uživatele
// s právem na datasource oracle a jiný pro ostatní. Cache 1 den.
export function useStationOwners() {
  const { data = [] } = useQuery({
    queryKey: ['stationOwners'],
    queryFn: () => api.get('/station_owner?cache=[1440]'),
    staleTime: Infinity,
    select: (rows) => rows.map(r => r.sow_name).filter(Boolean),
  })
  return data
}

export function useBasins() {
  const { data = [] } = useQuery({
    queryKey: ['basins'],
    queryFn: () => api.get('/basin'),
    staleTime: Infinity,
    select: (data) => data.map(b => b.basin),
  })
  return data
}

// Načte všechny stanice 1x a cachuje je
export function useAllStations() {
  const { data = [], isFetching: isLoading } = useQuery({
    queryKey: ['allStations'],
    //queryFn: () => api.get('/geography?join=[observation]'),
    queryFn: () => api.get('/geography?join=[observation]&observation.end_date=[group]&columns=[gh_id,begin_date,end_date,name,qual,full_name,h1,h2,h3,h4,elevation,latitude,longitude,wmo_id,icao_id,wsi,station_type,basin,sow_name,photo,observation.el_abbreviation,observation.obs_type,observation.end_date]&cache=[-1]'),
    staleTime: Infinity,
  })

  // Ulož do store
  const setAllStations = useStationStore((state) => state.setAllStations)
  useEffect(() => {
    setAllStations(data)
  }, [data, setAllStations])

  return { allStations: data, isLoading }
}

// Načte administrativní hierarchii zemí/krajů/okresů/ORP
export function useStationHierarchy() {
  const { data = [] } = useQuery({
    queryKey: ['stationHierarchy'],
    queryFn: () => api.get('/station_hierarchy'),
    staleTime: Infinity,
  })
  return data
}